import { Flex, Input } from '@lokalise/louis';
import { useEffect, useState } from 'react';

import trimRight from '@app/utils/string/trimRight';

import type { Ext } from '../../../../types';
import { Example } from '../../styles';

const useInternalValue = (value: string) => {
    const [internalValue, setInternalValue] = useState(value);

    useEffect(() => {
        setInternalValue(value);
    }, [value]);

    return [internalValue, setInternalValue] as const;
};

export interface FilenamesOriginalInputProps {
    value: string;
    ext: Ext;
    baseLangName: string;
    baseLangIso: string;
    projectName: string;
    onChange: (value: string) => void;
}

const FilenamesOriginalInput = ({
    value,
    ext,
    baseLangName,
    baseLangIso,
    projectName,
    onChange,
}: FilenamesOriginalInputProps) => {
    const [internalValue, setInternalValue] = useInternalValue(value);

    const example = trimRight(trimRight(internalValue, '/'), '/\\\\/')
        .replaceAll('%FORMAT%', ext)
        .replaceAll('%LANG_ISO%', baseLangIso)
        .replaceAll('%LANG_NAME%', baseLangName)
        .replaceAll('%PROJECT_NAME%', projectName);

    return (
        <Flex gap={1} direction="column">
            <Input
                aria-label="Custom folder structure"
                value={internalValue}
                onChange={(e) => setInternalValue(e.target.value)}
                onBlur={(e) => onChange(e.target.value)}
            />
            <Example>Example: {example}/</Example>
        </Flex>
    );
};

export default FilenamesOriginalInput;
